import { HTTP_TOKEN } from "./http";

export const getLists = (params) => {
  return HTTP_TOKEN.get("list", { params }).then((result) => {
    return result.data;
  });
};

export const createList = (data) => {
  return HTTP_TOKEN.post("list", data).then((result) => {
    return result.data;
  });
};


export const updateList = (list_id, data) => {
  return HTTP_TOKEN.put(`list/${list_id}`, data).then((result) => {
    return result.data;
  });
};

export const removeList = (list_id) => {
  return HTTP_TOKEN.delete(`list/${list_id}`).then((result) => {
    return result.data;
  });
};
